<h1
	mat-dialog-title
	class="dialog-title m-0 fw-bold fs-4 pb-3a"
>
	{{ "template.selector.title" | translate }}
</h1>
<div
	mat-dialog-content
	style="min-height: 70px"
>
	<!-- <mat-chip-list>
		<mat-chip
			*ngFor="let element of data.templates"
			(click)="selectRole(element)"
		>
		{{element.templateName}}
		</mat-chip>
	</mat-chip-list>
	<select (change)="selectRole($event.target.value)">
		<option
			*ngFor="let element of data.templates"
			[value]="element"
		>
			{{element.templateName}}
			</option>
	</select> -->

	<mat-form-field>
		<mat-select
			(selectionChange)="selectRole($event)"
			required
		>
			@for (type of data.templates; track type) {
				<mat-option [value]="type">
					{{ type.templateName }}
				</mat-option>
			}
		</mat-select>
	</mat-form-field>
</div>
<div
	class="justify-content-center"
	mat-dialog-actions
>
	<button
		class="text-center"
		class="btn btn-dark btn-lg"
		mat-button
		(click)="onClose(null)"
	>
		{{ "dialog.close" | translate }}
	</button>
</div>